<div class="mt-2 mb-2">
  <mat-accordion>
    <mat-expansion-panel
      [expanded]="panelOpenState()"
      (opened)="panelOpenState.set(true)"
      (closed)="panelOpenState.set(false)"
    >
      <mat-expansion-panel-header class="borderBottom">
        <mat-panel-title
          ><span class="title">Informazioni Generali</span></mat-panel-title
        >
        <mat-panel-description class="justify-content-end">
          @if (!saved) {
            <i
              class="bi bi-exclamation-circle-fill"
              style="color: red; font-size: large"
            ></i>
          }
          @if (saved) {
            <i
              class="bi bi-check-circle-fill"
              style="color: green; font-size: large"
            ></i>
          }
        </mat-panel-description>
      </mat-expansion-panel-header>

      <div class="container-fluid p-1 p-lg-2">
        <form [formGroup]="generalForm">
          <div class="row justify-content-start align-items-center">
            <div class="col-12 col-md-6 col-lg-4 mt-3">
              <label
                for="progressive"
                class="form-label"
                style="font-weight: bold"
              >
                Progressivo<sup>*</sup>
              </label>
              <div class="input-group" style="height: 40px">
                <input
                  type="text"
                  class="form-control"
                  placeholder="Progressivo"
                  id="progressivo"
                  formControlName="progressive"
                />
              </div>
            </div>
            <div class="col-12 col-md-6 col-lg-4 mt-3">
              <label for="title" class="form-label" style="font-weight: bold">
                Titolo<sup>*</sup>
              </label>
              <div class="input-group">
                <input
                  type="text"
                  class="form-control"
                  placeholder="Titolo della scheda"
                  id="title"
                  formControlName="title"
                  [class.is-invalid]="
                    generalForm.get('title')?.invalid &&
                    (submitted || generalForm.get('title')?.dirty)
                  "
                />
              </div>
            </div>
            <div class="col-12 col-md-6 col-lg-4 mt-3">
              <label
                for="region_code"
                class="form-label"
                style="font-weight: bold"
              >
                Codice regione
              </label>
              <select
                class="form-select mb-2"
                aria-label="Default select example"
                formControlName="region_code"
                id="region_code"
                [class.is-invalid]="
                  generalForm.get('region_code')?.invalid &&
                  (submitted || generalForm.get('region_code')?.dirty)
                "
              >
                <option [ngValue]="null" disabled>Seleziona un codice</option>
                @for (option of listRegionsCode; track option) {
                  <option [ngValue]="option.id" class="form-control">
                    {{ option.code }} - {{ option.definition }}
                  </option>
                }
              </select>
            </div>
            <div class="col-12 col-md-6 col-lg-4 mt-3">
              <label
                for="article_type"
                class="form-label"
                style="font-weight: bold"
              >
                Tipo di scheda<sup>*</sup>
              </label>
              <select
                class="form-select mb-2"
                aria-label="Default select example"
                formControlName="article_type"
                id="article_type"
                [class.is-invalid]="
                  generalForm.get('article_type')?.invalid &&
                  (submitted || generalForm.get('article_type')?.dirty)
                "
              >
                <option [ngValue]="null" disabled>
                  Seleziona una categoria
                </option>
                @for (option of listType; track option) {
                  <option [ngValue]="option.id" class="form-control">
                    {{ option.definition }}
                  </option>
                }
              </select>
            </div>
            <div class="col-12 col-md-6 col-lg-4 mt-3">
              <label
                for="general_catalog_number"
                class="form-label"
                style="font-weight: bold"
              >
                Numero catalogo generale
              </label>
              <div class="input-group" style="height: 40px">
                <input
                  type="text"
                  class="form-control"
                  placeholder="Numero catalogo generale"
                  id="general_catalog_number"
                  formControlName="general_catalog_number"
                  [class.is-invalid]="
                    generalForm.get('general_catalog_number')?.invalid &&
                    (submitted ||
                      generalForm.get('general_catalog_number')?.dirty)
                  "
                />
              </div>
            </div>
            <div class="col-12 col-md-6 col-lg-4 mt-3">
              <span class="form-label" style="font-weight: bold"
                >Visibilità articolo</span
              >
              <div class="visibility-controls">
                <label class="switch" for="public">
                  <input
                    id="public"
                    type="checkbox"
                    role="switch"
                    formControlName="public"
                    (change)="enableDisablePublication()"
                  />
                  <span class="switch-track" aria-hidden="true"></span>
                  <span>Pubblico</span>
                </label>
                @if (generalForm.get("public")!.value == 1) {
                  <input
                    id="public_year"
                    class="form-control public-year"
                    type="text"
                    inputmode="numeric"
                    maxlength="4"
                    placeholder="Anno"
                    formControlName="public_year"
                    aria-label="Anno pubblicazione"
                    (input)="isCorrectPublicYear()"
                    [class.is-invalid]="
                      generalForm.get('public_year')?.invalid &&
                      (submitted || generalForm.get('public_year')?.dirty)
                    "
                  />
                }
              </div>
              @if (
                generalForm.get("public")!.value == 1 &&
                generalForm.get("public_year")?.invalid &&
                generalForm.get("public_year")?.dirty
              ) {
                <span class="public-year-error"
                  >Campo numerico, range anni "attuale" - 9999</span
                >
              }
            </div>
          </div>
          <!-- <div class="row justify-content-start align-items-center">
            <div class="col-6 col-md-3 mt-3">
              <label for="floor" class="form-label" style="font-weight: bold;">
                Piano<sup>*</sup>
              </label>
              <div class="input-group" style="height: 40px;">
                <input type="text" class="form-control" placeholder="Piano edificio" id="floor" formControlName="floor"
                  [class.is-invalid]="generalForm.get('floor')?.invalid &&
                                        (submitted || generalForm.get('floor')?.dirty)">
              </div>
            </div>

            <div class="col-6 col-md-3 mt-3">
              <label for="room" class="form-label" style="font-weight: bold;">
                Stanza<sup>*</sup>
              </label>
              <div class="input-group" style="height: 40px;">
                <input type="text" class="form-control" placeholder="" id="room" formControlName="room"
                  [class.is-invalid]="generalForm.get('room')?.invalid &&
                                        (submitted || generalForm.get('room')?.dirty)">
              </div>
            </div>

            <div class="col-4 col-md-2 mt-3">
              <label for="rack" class="form-label" style="font-weight: bold;">
                Scaffale<span class="d-none d-lg-inline">/Armadio</span><sup>*</sup>
              </label>
              <div class="input-group" style="height: 40px;">
                <input type="text" class="form-control" placeholder="" id="rack" formControlName="rack"
                  [class.is-invalid]="generalForm.get('rack')?.invalid &&
                                        (submitted || generalForm.get('rack')?.dirty)">
              </div>
            </div>

            <div class="col-4 col-md-2 mt-3">
              <label for="shelf" class="form-label" style="font-weight: bold;">
                Ripiano<sup>*</sup>
              </label>
              <div class="input-group" style="height: 40px;">
                <input type="text" class="form-control" placeholder="" id="shelf" formControlName="shelf"
                  [class.is-invalid]="generalForm.get('shelf')?.invalid &&
                                        (submitted || generalForm.get('shelf')?.dirty)">
              </div>
            </div>

            <div class="col-4 col-md-2 mt-3">
              <label for="case" class="form-label" style="font-weight: bold;">
                Contenitore<sup>*</sup>
              </label>
              <div class="input-group" style="height: 40px;">
                <input type="text" class="form-control" placeholder="" id="case" formControlName="case"
                  [class.is-invalid]="generalForm.get('case')?.invalid &&
                                        (submitted || generalForm.get('case')?.dirty)">
              </div>
            </div>

            <div class="col-12 col-sm-6 mt-3">
              <label for="public" class="form-label" style="font-weight: bold;">Visibilità
                Articolo</label><br>
              <div class="form-check form-switch ms-1" style="margin-bottom: 1.6rem;">
                <input class="form-check-input form-control" type="checkbox" role="switch" id="public"
                  formControlName="public" checked style="cursor: pointer;" (change)="enableDisablePublication()">
                <label class="form-check-label" for="public">Pubblico</label>
              </div>
            </div>
            @if (generalForm.get('public')!.value == 1) {
            <div class="col-6">
              <label for="public_year" class="form-label" style="font-weight: bold;">Anno
                Visibilità
              </label>
              <div class="input-group mb-2" style="height: 38px;">
                <input type="text" class="form-control" placeholder="Anno Pubblicazione" id="public_year"
                  formControlName="public_year" (input)="isCorrectPublicYear()" [class.is-invalid]="generalForm.get('public_year')?.invalid &&
                                        (submitted || generalForm.get('public_year')?.dirty)">
              </div>
              @if (generalForm.get('public_year')?.invalid && generalForm.get('public_year')?.dirty) {
              <div>
                <span style="font-size: x-small; color: red;">Campo numerico, range anni 2024 - 9999</span>
              </div>
              }
            </div>
            }
          </div> -->

          <!-- IMMAGINI -->
          @if (idarticle > 0) {
            <div
              class="row justify-content-center align-items-center borderTop mt-3"
            >
              <div class="col-12 col-lg-6 text-center pt-2 mt-2">
                <div
                  class="row justify-content-center"
                  style="max-height: 500px; overflow-y: auto"
                >
                  @for (file of files; track file; let i = $index) {
                    <div class="col-1 mt-1" style="width: 80px; height: 80px">
                      @if (file.ext != "pdf") {
                        <img
                          [src]="urlServerLaraApiMultimedia + file.src"
                          class="img-fluid thumbnailImg"
                          [title]="file.title"
                          (click)="visualizeImg(file.id)"
                        />
                      }
                      @if (file.ext == "pdf") {
                        <img
                          src="assets/img/pdfThumbnail.png"
                          class="img-fluid thumbnailImg"
                          [title]="file.title"
                          (click)="visualizeImg(file.id)"
                        />
                      }
                      <i
                        class="bi bi-trash"
                        style="color: red; margin-right: 5px"
                        (click)="deleteImg(file.id)"
                      ></i>
                      @if (file.cover === 0) {
                        <i
                          class="bi bi-star"
                          style="color: green; margin-left: 5px"
                          (click)="changeCover(file.id)"
                        ></i>
                      }
                      @if (file.cover === 1) {
                        <i
                          class="bi bi-star-fill"
                          style="color: green; margin-left: 5px"
                        ></i>
                      }
                    </div>
                  }
                </div>
                <div class="row justify-content-center">
                  <div class="col-12 col-md-8 col-lg-6 mt-3">
                    <label for="fileUpload" class="btn btn-outline-dark">
                      <i class="bi bi-upload"></i>
                      <span style="margin-left: 10px">Carica Immagine</span>
                      <input
                        type="file"
                        id="fileUpload"
                        style="display: none"
                        (change)="onFileSelected($event)"
                        accept="*"
                      />
                    </label>
                  </div>
                </div>
              </div>
            </div>
          }
        </form>

        <div class="row justify-content-center mt-4 borderTop">
          @if (generalForm.invalid && submitted) {
            <div class="col-12 mt-2 text-center">
              <small>
                Compilare correttamente tutti i campi obbligatori per abilitare
                il salvataggio
              </small>
            </div>
          }
          <div class="col-12 col-md-6 col-lg-4 mt-1 text-center">
            <button class="btn btn-outline-dark" (click)="save()">Salva</button>
          </div>
        </div>
      </div>
    </mat-expansion-panel>
  </mat-accordion>
</div>
